import memoize from 'lodash/memoize';

/**
 * Add new feature names to this type:
 * type Feature = 'SomeFeature' | 'AnotherFeature' | 'SomeNewFeature'
 * PRO TIP: Use alphabetical ordering; if everyone adds at the top or bottom
 * it increases the chance of merge conflicts.
 */
export type Feature =
  /* INSERT FEATURES POINT - DO NOT REMOVE THIS LINE */
  | 'AnalyticsCardOnFile'
  | 'AnalyticsInitiativeTracking'
  | 'AnalyticsInventoryIntegration'
  | 'AnalyticsInventoryIntegrationDisable'
  | 'AnalyticsPromoV2'
  | 'AnalyticsUpsell'
  | 'B2bCatalogContextualizedItemMatching'
  | 'B2bCatalogVendorImport'
  | 'B2bMerchantContextualizedVendorMatching'
  | 'B2bMerchantPurchaseExport'
  | 'B2bNuorderIntegration'
  | 'B2bWholesaleV2'
  | 'BugFixAddNegativePriceItemsDoNotForceEdit'
  | 'BugfixLoggingForPaymentFlow'
  | 'BugfixTaxclassPresaveAssignment'
  | 'CapitalExpansion'
  | 'CapitalRoutesStripeSplitFunding'
  | 'CapitalSourceContext'
  | 'CatalogB2bIntegration'
  | 'CatalogB2bMatrixIntegration'
  | 'CreditAccountDisabled'
  | 'CustomerCardMinimumFiftyCents'
  | 'CustomerCardOnFile'
  | 'CustomerCardOnFileDepositFix'
  | 'CustomerCardOnFileMotoNoDelay'
  | 'CustomerCardOnFileNickname'
  | 'CustomersInvoicingIntegrationCustomerProfileWebComponents'
  | 'CustomersInvoicingIntegrationDisableExistingCustomerStatementFlows'
  | 'CustomersInvoicingIntegrationFreeTier'
  | 'CustomersInvoicingIntegrationIncreasemakepaymentactions'
  | 'CustomersInvoicingIntegrationPaymentRequest'
  | 'CustomersInvoicingPaymentCaptured'
  | 'CustomerWorkorderCreationBug'
  | 'DataPanDetectionBlock'
  | 'DataPanDetectionGatewayCheck'
  | 'DataPanDetectionRedactingMigration'
  | 'DataPanDetectionRedactionMigrationSkip'
  | 'DataPanDetectionReport'
  | 'DataPanDetectionReportUpdates'
  | 'DataPanDetectionTracker'
  | 'DataPanDetectionWarn'
  | 'DataPanDetectionWarnBugfix'
  | 'EInvoicing'
  | 'FinancialServicesPortal'
  | 'GiftReceiptFixNonInventoryItems'
  | 'GuiPaymentQuickpayV2'
  | 'HubAdvancedLocalServer'
  | 'IntercomEnableChat'
  | 'IntercomFrontendLogging'
  | 'InventoryCountImprovementsImport'
  | 'InventoryCountScanQueue'
  | 'InventoryCountScanRefactor'
  | 'InvoicingApiV1'
  | 'InvoicingApiV1BalanceDrift'
  | 'InvoicingApiV1CleanupIntents'
  | 'InvoicingApiV1ConsumeDeposit'
  | 'InvoicingApiV1CreditAccountBalance'
  | 'InvoicingApiV1DepositInstructions'
  | 'InvoicingApiV1PaymentInstructions'
  | 'InvoicingApiV1PaymentMethodSettings'
  | 'InvoicingApiV1RefundIntent'
  | 'InvoicingApiV1ReturnInstructions'
  | 'ItemFees'
  | 'ItemFeesOptimizationFixOn2'
  | 'ItemFeesPercent'
  | 'ItemFeesPercentShopFiltering'
  | 'ListingBulkDelete'
  | 'MonitoringDatadogLogs'
  | 'MonitoringDatadogSampleOverwrite'
  | 'NavigationRerouteToSubscriptionsPageWhenLocked'
  | 'NuorderB2bCatalogBanner'
  | 'NuorderInventoryBanner'
  | 'NuorderMasterOrderBanner'
  | 'NuorderNewPoBanner'
  | 'NuorderPoProductImportBanner'
  | 'NuorderSidemenuNotificationBadge'
  | 'NuorderVendorCatalogPopup'
  | 'NuorderVendorsShowNewTile'
  | 'OmniAllowEditEcomEntities'
  | 'PaymentsCaptureFlow'
  | 'PaymentsClientSideCancelPayment'
  | 'PaymentsCloudPing'
  | 'PaymentsDepositInteracRefunds'
  | 'PaymentsDeprecatedTerminal'
  | 'PaymentsFixForCcDepositInteracRefunds'
  | 'PaymentsFixPolling'
  | 'PaymentsMonitoringStartTime'
  | 'PaymentsPreAuth'
  | 'PaymentsPreferMotoWidget'
  | 'PaymentsProcessingRollout'
  | 'PaymentsRefreshSaleRetry'
  | 'PaymentsReplaceSetupIntentParameter'
  | 'PaymentsSalelineRefreshBugDiagnosis'
  | 'PaymentsSettingsAllowUk'
  | 'PaymentsSurcharge'
  | 'PaymentsTerminalCustomerFacingDisplay'
  | 'PaymentsTerminalMonitoring'
  | 'PaymentsTerminalTipping'
  | 'PaymentsWebFlowForIosManagerMode'
  | 'PurchaseOrderLandedCostsManualDiscountAdjustment'
  | 'PurchaseOrderLandedCostsSpreadCosts'
  | 'RegisterAgeVerificationFlowAdjustment'
  | 'RegisterCfdChannelLogging'
  | 'RegisterPaymentAllowZeroSaleTotal'
  | 'RegisterPaymentDepositByPaylink'
  | 'RegisterPaymentLinkPaymentLinkRefunds'
  | 'RegisterPaymentRefundableCreditPayments'
  | 'RegisterPaymentScanDepositFix'
  | 'RegisterPreserveLineInlineEditState'
  | 'RegisterSalesCashRounding'
  | 'RegisterSalesCashRoundingWebhookPreflight'
  | 'RegisterSaleShowUnitCount'
  | 'RegisterTerminalSwitchTracking'
  | 'ReportingProcessingServiceTransactionDetails'
  | 'ReportsCapitalBanner'
  | 'ReportsCapitalHeapErrorBoundary'
  | 'ReportsCapitalInventoryExperiment'
  | 'ReportsCapitalInventoryExperimentV2'
  | 'ReportsCapitalRoles'
  | 'ReportsCapitalTrackFinancialAdminAloneOnStart'
  | 'SettingsPaymentProcessingDirectDebit'
  | 'SettingsReceiptEditor'
  | 'ShippingEnforceSerialNumbers'
  | 'SubscriptionInvoiceNotification'
  | 'SubscriptionInvoiceService'
  | 'SubscriptionMerchantAccountSpace'
  | 'SupportNetworkHealthTool'
  | 'SupportNetworkHealthToolDebug'
  | 'SupportNetworkHealthToolDisplayUi'
  | 'SupportNetworkHealthToolDisplayUiReporting'
  | 'SupportUniversalSupportCode'
  | 'TransactionsRefundSerializedItemImprovements'
  | 'UiNavigationBlockerUnified'
  | 'VendorReturnsSerialized'
  | 'WorkorderBugfixStatusId'
  | 'WorkorderCalendarFeed'
  | 'WorkordersSerializedItemImprovements';

/**
 * Consumes the admin features endpoint to get a list of the enabled feature flags.
 * Multiple calls are memoised until the cache is cleared by getFeatures.cache.clear?.()
 */
export const getFeatures = memoize(async (): Promise<Record<Feature, boolean>> => {
  const response = await window.fetch('/admin/features');
  const json = await response.json();
  return json;
});

/**
 * Checks if a specific feature flag is enabled. To clear the cache call getFeatures.cache.clear?.()
 *
 * Example:
 * async function testFunction() {
 *  if (await hasFeature("SomeNewFeature")) {
 *    // do something
 *  } else {
 *    // do something else
 *  }
}
 */
export const hasFeature = async (featureName: Feature): Promise<boolean> => {
  const features = await getFeatures();
  return features[featureName] === true;
};
